import { Transfer } from 'antd';
import styled from 'styled-components';

export default styled(Transfer)`
	// Add your styles here
`;
